import{ Component, OnInit, HostListener, ChangeDetectorRef, Input, EventEmitter, Output, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'navpoint',
    templateUrl: 'navmenu.template.html',
    styleUrls: ['navmenu.style.scss'],
    encapsulation: ViewEncapsulation.None
})


export class NavPoint{
    public hovered: boolean;
    @Input() item : any;
    @Input() primary : boolean;
    @Input() parent : string;

   //@Output('hovered') hovered = new EventEmitter() 
    @HostListener('mouseenter') onMouseEnter(event){
        this.hovered = true;
   
    }
    @HostListener('mouseleave') onMouseLeave(event){
        this.hovered = false;
    }

    
    
    constructor(
        private router: Router,
        private activeRoute: ActivatedRoute,
        private changeDetector: ChangeDetectorRef,
        private interactions : EventInteraction,
        private el : ElementRef
    ){
        this.el = el;
    }


    private ngOnInit(){

    }

    private delay(index): any{
        let styles = {}
         styles[ 'transition-delay'] =  (index * .02).toString() + 's';
         return styles;
    }
  
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/navbar/navmenu.component.ts